import { useId } from 'react';

export interface RadioButtonProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  id?: string;
  name?: string;
  value?: string;
}

export function RadioButton({
  checked = false,
  onChange,
  label,
  disabled = false,
  id,
  name,
  value,
}: RadioButtonProps) {
  const generatedId = useId();
  const radioId = id ?? generatedId;

  return (
    <div className="inline-flex items-center gap-2">
      <button
        type="button"
        role="radio"
        aria-checked={checked}
        id={radioId}
        disabled={disabled}
        data-name={name}
        data-value={value}
        onClick={() => onChange?.(!checked)}
        className={[
          'inline-flex items-center justify-center w-5 h-5 rounded-full border-2 shrink-0 cursor-pointer',
          'transition-colors duration-150',
          'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          checked ? 'border-primary' : 'bg-background border-border',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        {checked && <span className="w-2.5 h-2.5 rounded-full bg-primary" />}
      </button>
      {label && (
        <label
          htmlFor={radioId}
          className={[
            'text-sm text-foreground select-none',
            disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
          ].join(' ')}
        >
          {label}
        </label>
      )}
    </div>
  );
}
